import axios from 'axios';
import Cookies from 'js-cookie';

const errorMessages = {
    'error.bad_request': 'Your request is invalid.',
    'error.un_authorized': 'Enter correct User name and Password.',
    'error.forbidden': 'The kitten requested is hidden for administrators only.',
    'error.notfound': 'Requested object Not found.',
    'error.method_not_allowed': 'You tried to access a kitten with an invalid method.',
    'error.not_acceptable': 'You requested a format that isn\'t json.',
    'error.too_many_requests': ' You\'re requesting too many kittens! Slow down!',
    'error.internal_server_error': 'We had a problem with our server. Try again later.',
    'error.service_unavailable': 'We\'re temporarily offline for maintenance. Please try again later.',
    'error.undefined': 'Unhandled server error',
    'error.noresponse': 'Failed to get any response',
};


function mapBodyToFormData(body) {
    const formD = new FormData();

    for (let key in body) {
        let bodyData = body[key];

        // Check if the data is an array
        if (Array.isArray(bodyData)) {
            if (bodyData.length > 0 && !(bodyData[0] instanceof File)) {
                formD.append(key, JSON.stringify(bodyData));
            } else {
                bodyData.forEach(obj => {
                    if (obj instanceof File) {
                        formD.append(key + '[]', obj);
                    } else {
                        formD.append(key, JSON.stringify(obj)); // Optional: If obj is not a File
                    }
                });
            }
        } else {
            let value = body[key];
            formD.append(key, value); // Append simple value
        }
    }

    return formD;
}



const perform_request = (method = 'POST', path, token = false, body, formData = false, headerParam = null, onProgress = null) => {
    return new Promise((resolve, reject) => {
        const userToken = Cookies.get('access_token');
        // console.log('New Request fired URL : ' + [BASE_URL, path].join('/'));
        let headers = {
            // 'Content-type': 'application/json',
        };

        // if (formData) {
        //     headers['Content-type'] = 'multipart/form-data; application/json; charset=utf-8';
        // }


        // Fetch token from redux store
        if (token && token === true && userToken) {
            headers['Authorization'] = 'Bearer ' + userToken;
        }

        if (headerParam) {
            headers = {
                ...headers,
                ...headerParam
            }
        }

        let fullHeaderBody = {
            method,
            headers,
            url: "/api/" + path,
        };


        if (body) {
            if (formData) {
                // If body is already FormData, send as-is; otherwise convert plain object to FormData
                fullHeaderBody.data = body instanceof FormData ? body : mapBodyToFormData(body);
            } else {
                if (method.toLowerCase() !== 'get') {
                    fullHeaderBody.data = body;
                } else {
                    fullHeaderBody.params = JSON.stringify(body);
                }

            }
        }

        // FIX : https://github.com/axios/axios/issues/4576#issuecomment-1103982385
        // ((transforms) => {
        //     const [original] = transforms;
        //     const isFormData = (thing) => {
        //         let pattern = '[object FormData]';
        //         return (
        //             thing &&
        //             ((typeof FormData === 'function' && thing instanceof FormData) ||
        //                 toString.call(thing) === pattern ||
        //                 (typeof thing.toString === 'function' && thing.toString() === pattern))
        //         );
        //     };
        //
        //     transforms[0] = function hotFix(data, headers) {
        //         return !original || isFormData(data) ? data : original(data, headers);
        //     };
        // })(axios.defaults.transformRequest);

        axios(fullHeaderBody, {
            onUploadProgress: (progressEvent) => {
                if (onProgress) {
                    const uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                    onProgress(uploadProgress)
                }
            },
        }).then(response => {
            if (response.data.code === 401) {
                reject({body: null, error: 'Session has expired'});
            }
            resolve({body: response.data, error: null, code: response.status});

        }).catch(error => {
            let errorResponse = {
                body: null,
                error: 'Something unexpected happened',
                code: error.response && error.response.status ? error.response.status : 500,
            };
            if (error.response && error.response.status) {
                // Check if the response has a meaningful error message
                if (error.response.data && error.response.data.message) {
                    errorResponse.error = error.response.data.message;
                    errorResponse.body = error.response.data;
                } else {
                    // Fallback to default error messages
                    switch (error.response.status) {
                        case 400:
                            errorResponse.error = errorMessages['error.bad_request'];
                            break;
                        case 401:
                            window.location.href = "/logout"
                            errorResponse.error = 'Session has expired';
                            break;
                        case 404:
                            errorResponse.error = errorMessages['error.notfound'];
                            break;
                        case 500:
                            errorResponse.error = errorMessages['error.internal_server_error'];
                            break;
                        default:
                            break;
                    }
                }
            } else if (error.request) {
                errorResponse.error = errorMessages['error.noresponse'];
            } else {
                console.log('Error', error.message);
            }
            reject(errorResponse);
        });
    });
};

export default perform_request;
